import { SwellGetRateAbi } from '../abis/swell'
import { TotalSupplyAbi } from '../abis/shared'
import type { LstRegistryEntry } from '../registry'
import { ONE_E18, toBigInt, type LstReader } from './shared'

/**
 * Swell rswETH reader — `getRate()`.
 *
 * Two calls: `rswETH.totalSupply()` + `rswETH.getRate()`. Both 1e18.
 *
 * swETH (the older LST at `0xf951…d78`) uses a different exchange-rate
 * getter and is intentionally not in the registry yet — re-add once
 * its selector is verified against the deployed contract.
 */
export const readerSwellGetRate = (entry: LstRegistryEntry): LstReader => ({
  calls: [
    { address: entry.address, name: 'totalSupply', params: [] },
    { address: entry.address, name: 'getRate', params: [] },
  ],
  abis: [TotalSupplyAbi, SwellGetRateAbi],
  parse: ([supply, rate]) => {
    const totalSupply = toBigInt(supply)
    const exchangeRate = toBigInt(rate)
    if (totalSupply === undefined || exchangeRate === undefined) {
      return undefined
    }
    return {
      totalAssets: (totalSupply * exchangeRate) / ONE_E18,
      totalSupply,
      exchangeRate,
    }
  },
})
